// Carry Roll RollSegmentView — ground-roll/bounce segment (7.2). Renders roll path detail.

import { useResult } from '../../store/selectors';
import { useStore } from '../../store';
import { convertDistance } from '@carry-roll/shared-logic';

export function RollSegmentView() {
  const result = useResult();
  const distanceUnit = useStore((s) => s.distanceUnit);
  const rollPath = result.rollPath;

  if (rollPath.length < 2) {
    return (
      <div data-testid="roll-segment-view" className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
        ▼ Roll segment: minimal roll on this shot.
      </div>
    );
  }

  const conv = (m: number) => convertDistance(m, distanceUnit);
  const start = rollPath[0]!.x;
  const end = rollPath[rollPath.length - 1]!.x;

  return (
    <div data-testid="roll-segment-view" className="text-xs" style={{ color: 'var(--color-roll)' }}>
      ▼ Roll segment: {Math.round(conv(end - start))} {distanceUnit} ground run-out from {Math.round(conv(start))} to{' '}
      {Math.round(conv(end))} {distanceUnit}.
    </div>
  );
}
